import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button } from 'primereact/button';
import InputFieldIconText from '../../../../components/Widgets/Inputs/InputFieldIconText';
import InputPassword from '../../../../components/Widgets/Inputs/InputPassword';
import './WhatsappLogin.scss';
import PhoneInput from 'react-phone-input-2';
import { parseJwt } from '../../../../service/JwtUtils';
import PostRequest from '../../../../service/PostRequest';
import BOSS_mainlogo from '../../../../assets/icons/BOSS_mainlogo.svg';
import WhatsappIcon from '../../../../assets/icons/WhatsappIcon.svg';
import GoogleIcon from '../../../../assets/icons/GoogleIcon.svg';
import MailIcon from '../../../../assets/icons/MailIcon.svg';
import CookieHandler from '../../Authentication/CookieHandler';
import { Message } from 'primereact/message';

const WhatsappLogin = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [loading, setLoading] = useState(false);
  const [messageTimer, setMessageTimer] = useState(null);

  useEffect(() => {
    return () => {
      if (messageTimer) {
        clearTimeout(messageTimer);
      }
    };
  }, [messageTimer]);

  const handlePopupOpen = () => {
    setOpen(true);
  };

  const handlePhoneNumberChange = (value) => {
    setPhoneNumber(value);
    setEmailError("");
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setPasswordError("");
  };

  const showMessage = (message, type, duration = 3000) => {
    setMessage(message);
    setMessageType(type);
    if (messageTimer) {
      clearTimeout(messageTimer);
    }
    const timer = setTimeout(() => {
      setMessage("");
      setMessageType("");
    }, duration);
    setMessageTimer(timer);
  };

  const handleLogin = async () => {
    setEmailError("");
    setPasswordError("");

    let isValid = true;

    if (!phoneNumber.trim()) {
      setEmailError("Phone number is required");
      isValid = false;
    }

    if (!password.trim()) {
      setPasswordError("Password is required");
      isValid = false;
    }

    const data = { phoneNumber: `+${phoneNumber}`, password: password };

    if (isValid) {
      try {
        setLoading(true);
        const response = await PostRequest('auth/login', data, false);

        if (response === undefined) {
          showMessage("Login Error: Server Response is undefined", 'info');
        } else {
          const { data, status } = response;

          if (status === 200 || status === 201) {
            CookieHandler.setTokens({
              customerName: data.customerName,
              token: data.jwtToken,
              expiresIn: data.expiresIn,
              refreshToken: data.refreshToken,
              refreshExpiresIn: data.refreshExpiresIn,
              phoneNumber: phoneNumber,
              userRoles: data.userRoles.join(','), // Store userRoles as a comma-separated string
              userId: data.userId,
              isLoggedIn: true // Ensure isLoggedIn is set correctly
            });

            const jwtToken = CookieHandler.getCookie('token');
            if (jwtToken) {
              const decodedToken = parseJwt(jwtToken);
              console.log("Decoded Token: ", decodedToken); // Log decoded token
              const role = decodedToken.roles[0];
              console.log("User Role: ", role); // Log user role
              CookieHandler.setCookie("userRole", role);
              navigateBasedOnRole(role);
            } else {
              console.warn("JWT token not found after login.");
            }
          } else {
            showMessage(data.message, 'error');
          }
        }
        setLoading(false);
      } catch (error) {
        showMessage(`Login failed: ${error.message || error.toString()}`, 'error');
        setLoading(false);
      }
    }
  };

  const navigateBasedOnRole = (role) => {
    if (role === "ROLE_STORE_MANAGER") {
      console.log("Navigating to /store"); // Log navigation
      navigate("/store");
    } else if (role === "ROLE_CUSTOMER") {
      handlePopupOpen();
    }
  };

  return (
    <div className='SigninSignupContainer'>
      <div className='Heading'>
        <img src={BOSS_mainlogo} alt="boss logo" />
      </div>
      <div className="LeftandRightContainer">
        <div className='SignupContainer'>
          <h3>Sign up</h3>
          <div className='SignupButtons'>
            <div className='SignupOption WhatsappSignup' onClick={() => navigate('/whatsapp-register')}>
              <img src={WhatsappIcon} alt="whatsappicon" />
              <h4>Whatsapp</h4>
            </div>
            <a href="https://dev.boss-api.m2r2.co.uk/api/auth/oauth2/authorization/google">
              <div className='SignupOption GoogleSignup'>
                <img src={GoogleIcon} alt="GoogleIcon" />
                <h4>Google</h4>
              </div>
            </a>
            <div className='SignupOption MailSignup' onClick={() => navigate('/email-signup')}>
              <img src={MailIcon} alt="MailIcon" />
              <h4>e-mail</h4>
            </div>
          </div>
          <p>By signing up, you agree to the <a href="/terms-of-service">Terms of Service</a> <br />
            and acknowledge you’ve read our <a href="/privacy-policy">Privacy Policy.</a> 
          </p>
        </div>
        <div className="VerticalDivider"></div>
        <div className='SigninContainer'>
          <h3>Log in</h3>
          <div className='SigninInputs'>
            <label>Whatsapp Number</label>
            <div className='EmailInput'>
              <PhoneInput
                country={"gb"}
                enableSearch={true}
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
              />
              {emailError && <div className="error-message">{emailError}</div>}
            </div>
            <label>Password</label>
            <div className='PasswordInput'>
              <InputPassword value={password} label="Password" onChange={handlePasswordChange} errorMessage={passwordError} style={{width:"300px"}} />
            </div>
            {message && (
              <Message severity={messageType} text={message} />
            )}
          </div><br />
          <div className='ForgotPassword'>
            <a href="/forgot-password-whatsapp">Forgot Password?</a>
          </div>
          <br />
          <Button label="Login" severity="primary" onClick={handleLogin} style={{width:"340px", borderRadius:"40px", fontSize:"18px"}} loading={loading} />
          <br /><p style={{textAlign:"center",fontWeight:"bold"}}>or</p>
          <div className='SinginButtons'>
            <div className='SignupOption WhatsappSignup' onClick={() => navigate('/login')}>
              <img src={MailIcon} alt="MailIcon" />
              <h4>e-mail</h4>
            </div>
            <a href="https://dev.boss-api.m2r2.co.uk/api/auth/oauth2/authorization/google">
              <div className='SignupOption GoogleSignup'>
                <img src={GoogleIcon} alt="GoogleIcon" />
                <h4>Google</h4>
              </div>
            </a>
          </div>
        </div>
      </div>
     
    </div>
  );
}

export default WhatsappLogin;
